import { TRANSACTION_TYPES } from '../utils/constants';

const hardCapsRoutes = [

    {
        path: '/hard-caps',
        name: 'HardCapsPage',
        component: () => import('../views/hardcaps/HardCapsComponent.vue'),
        meta: {
            requiresAuth: true,
            roles: ['SUPERADMIN'],
            module: 'hardCaps',
        },
    },

    {
        path: '/hard-caps/create',
        name: 'HardCapsCreatePage',
        component: () => import('../views/hardcaps/HardCapsManagerComponent.vue'),
        props: { type: TRANSACTION_TYPES.CREATE },
        meta: {
            requiresAuth: true,
            roles: ['SUPERADMIN'],
            module: 'hardCaps',
        },
    },

    {
        path: '/hard-caps/edit/:hardCapId',
        name: 'HardCapsEditPage',
        component: () => import('../views/hardcaps/HardCapsManagerComponent.vue'),
        props: (route) => ({ type: TRANSACTION_TYPES.EDIT, hardCapId: route.params.hardCapId }),
        meta: {
            requiresAuth: true,
            roles: ['SUPERADMIN'],
            module: 'hardCaps',
        },
    },

    {
        path: '/hard-caps/show/:hardCapId',
        name: 'HardCapsShowPage',
        component: () => import('../views/hardcaps/HardCapsManagerComponent.vue'),
        props: (route) => ({ type: TRANSACTION_TYPES.SHOW, hardCapId: route.params.hardCapId }),
        meta: {
            requiresAuth: true,
            roles: ['SUPERADMIN'],
            module: 'hardCaps',
        },
    },

];

export default hardCapsRoutes;
